
import { component } from '@/helpers/vueTyped';
import store, { dispatch } from '@/store';
import { Summary } from '@/api/validators/content';
import { config } from '@/config';
import HighlightSection from '@/components/SharedViews/HighlightSection/HighlightSection.vue';
import CardRailContainer from '@/components/SharedViews/CardRail/CardRailContainer.vue';
import ExitDialog from '@/components/SharedViews/Dialogs/ExitDialog.vue';

export default component()({
  name: 'Home',

  data() {
    return {
      focusedCardSummary: undefined as Summary | undefined,
      hideArticleRail: false,
      exitDialogOpen: false,
    };
  },

  computed: {
    drawerOpen() { return store.state.drawerOpen; },
  },

  methods: {
    focus() {
      this.hideArticleRail = false;
      (this.$refs.articlerail as InstanceType<typeof CardRailContainer>).focus();
    },

    cardFocusHandler(summary: Summary) {
      dispatch('setBackgroundOptions', [{ url: `${config.cdn}${summary.image}`, type: 'home' }]);

      this.focusedCardSummary = summary;
    },

    newsRailFocusHandler() {
      this.hideArticleRail = false;
    },

    videoRailFocusHandler() {
      this.hideArticleRail = true;
    },

    handleBack(nodes: any, container: any, next: () => void) {
      if (!this.drawerOpen) {
        next();
        return false;
      }

      dispatch('pushNavigationContext');
      this.exitDialogOpen = true;
    },

    closeExitDialog() {
      this.exitDialogOpen = false;

      dispatch('popNavigationContext');

      const context = store.state.navigationContext;

      if (context?.activeElement) {
        context.activeElement[0].focus();
      }
    },
  },

  created() {
    dispatch('setCurrentSport', [undefined]);
    dispatch('setCurrentTournament', [undefined]);

    this.$spatialFocus.pushGlobalOverride('back', this.handleBack);
  },

  destroyed() {
    this.$spatialFocus.popGlobalOverride('back');
  },

  render() {
    return (
      <div v-spatial-container onFocus={this.focus}>
        <HighlightSection class='highlight-section' summary={this.focusedCardSummary}/>
        <div class='rails-container'>
          <CardRailContainer
            ref='articlerail'
            class={['rail', this.hideArticleRail && 'hide-rail']}
            onFocus={this.newsRailFocusHandler}
            cardFocusCallback={this.cardFocusHandler}
            firstCardLoadedCallback={this.cardFocusHandler}
            feedType='article'
            summaryType='articles'
            categoryName='Latest News'
          />
          <CardRailContainer
            class='rail video-rail'
            onFocus={this.videoRailFocusHandler}
            cardFocusCallback={this.cardFocusHandler}
            feedType='video'
            summaryType='video'
            categoryName='Latest Video'
          />
        </div>
        {this.exitDialogOpen && (
          <portal>
            <ExitDialog closedCallback={this.closeExitDialog}/>
          </portal>
        )}
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2af29a46/Home.vue" });